import request from '@/utils/request'

const tradeSellContractAttachmentApi = {
  trade_sell_contract_attachment_list: '/trade/sell_contract_attachment/',
  trade_sell_contract_attachment_create: '/trade/sell_contract_attachment/',
  trade_sell_contract_attachment_update: '/trade/sell_contract_attachment/',
  trade_sell_contract_attachment_delete: '/trade/sell_contract_attachment/'
}

/**
 * 列表
 */
export function sell_contract_attachment_list (parameter) {
  return request({
    url: tradeSellContractAttachmentApi.trade_sell_contract_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function sell_contract_attachment_create (parameter) {
  return request({
    url: tradeSellContractAttachmentApi.trade_sell_contract_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function sell_contract_attachment_update (parameter, sell_contract_attachment_id) {
  return request({
    url: tradeSellContractAttachmentApi.trade_sell_contract_attachment_update + sell_contract_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function sell_contract_attachment_delete (sell_contract_attachment_id) {
  return request({
    url: tradeSellContractAttachmentApi.trade_sell_contract_attachment_delete + sell_contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
